export default __webpack_public_path__ + "static/media/KTMW-Organizer.dfb8a89b.png";